<!-- <app-background-video></app-background-video> -->
<app-background-image data-state="terminal"></app-background-image>

<app-topbar></app-topbar>

<nav class="sidebar navbar-dark bg-dark"></nav>

<div class="main-content">
    <div class="tile-box">
        <app-tile
            text="Workflow dashboards"
            icon="../../assets/agency.svg"
            link="dashboard"
            [disabled]="!userCan.getAccsessToTerminalDashboard"
        ></app-tile>

        <app-tile
            text="Vehicle overview"
            icon="../../assets/terminal.svg"
            link="vehicles"
            [disabled]="!userCan.getAccsessToTerminalVehicles"
        ></app-tile>

        <app-tile
            text="Storage overview"
            icon="../../assets/logistik.svg"
            link="storage"
            [disabled]="!userCan.getAccsessToTerminalStorage"
        ></app-tile>
    </div>
</div>
